import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-DE",
  "use": "icon-DE-usage",
  "viewBox": "0 0 24 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 18\" id=\"icon-DE\"><g clip-path=\"url(#icon-DE_a)\"><path d=\"M0 12h24v6H0v-6Z\" fill=\"#FFCE00\" /><path d=\"M0 0h24v6H0V0Z\" fill=\"#000\" /><path d=\"M0 6h24v6H0V6Z\" fill=\"#D00\" /></g><defs><clipPath id=\"icon-DE_a\"><path fill=\"#fff\" d=\"M0 0h24v18H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol